import React from "react";
import Button from "../../../../../../_components/Button";
import Modal from "../../../../../../_components/Modal";
import Text from "../../../../../../_components/Text";
import LoadingInput from "../../../../../../_components/LoadingInput";
import { showSnackBar } from "../../../../../../utils";
import { disableNFe } from "../../../../../../api/nfe";

export default (props) => {
  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [reason, setReason] = React.useState("Pulos de numeração");

  function onShow() {
    setShow(true);
    setTimeout(() => {
      onSetInputFocus();
    }, 500);
  }
  function onHide() {
    if (loading) {
      return;
    }
    setShow(false);
    setReason("Pulos de numeração");
    setLoading(true);
  }
  function onSetInputFocus() {
    try {
      document.querySelector('[name="xpto"]').focus();
    } catch (error) {}
  }
  function onDisable() {
    if (reason.length < 15) {
      showSnackBar("");
      return;
    }
    setLoading(true);
    disableNFe(props.nfe.id)
      .then((resp) => {
        if (props.onFinally) {
          props.onFinally();
        }
        onHide();
        showSnackBar("Numeração Inutilizada!", "info")
      })
      .catch((resp) => {
        setLoading(false)
        if (resp.error) {
          showSnackBar(resp.error, "danger", 10000);
        }
      });
  }

  return (
    <React.Fragment>
      <Button
        onClick={onShow}
        as="text"
        disabled={props.nfe.status != 3}
        className="text-warning mx-1"
      >
        <i className="fas fa-ban" /> <span>Inutilizar numeração</span>
      </Button>
      <Modal
        title={`Inutilizar Numeração: ${props.nfe.number}`}
        show={show}
        onHide={onHide}
      >
        <Text>Justificativa de cancelamento</Text>
        <div className="py-2">
          <LoadingInput
            name="xpto"
            value={reason}
            loading={loading}
            onChange={(e) => setReason(e.target.value)}
          />
          <span
            className={`${
              reason.length < 15 ? "d-block text-danger" : "d-none"
            }`}
          >
            A Justificativa não pode ter menos do que <strong>15</strong>{" "}
            caracteres
          </span>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            disabled={loading || reason.length < 15}
            onClick={onDisable}
            as="text"
          >
            Inutilizar numeração
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/DisabledNFe/index.jsx